<template>
    <div class="cost">
        <div class="container">
            <div class="title title--ms title--uppercase title--mb4" v-html="$lang('PlaceLandingCost.title')"/>

            <div class="cost__block shadow" v-for="(service, index) in services" :key="index">
                <div class="cost__content">
                    <div class="cost__header">
                        <div class="title title--ms title--uppercase cost__title" v-html="service.name"/>

                        <div class="cost__switch">
                            <div class="cost__price">
                                {{ service.price | priceFormat }}

                                <span class="cost__currency" v-html="$lang('PlaceLandingCost.currency')"></span>
                            </div>

                            <el-switch class="switch switch--big switch--end-right"
                                       v-model="service.selected"
                                       :disabled="index === 0"
                            />
                        </div>
                    </div>

                    <p class="cost__desc" v-html="service.description"/>
                </div>
            </div>
        </div>

        <div class="add__buttons add__buttons--sticky add__buttons--sticky-gray" id="save">
            <div class="container cost__sum--container">
                <router-link :to="{ name: 'place-feedback', params: { title: $lang('placeLanding.feedback.title'), sum: sum, services: getSelectedServices() }}"
                             class="btn btn--big btn--main-bg cost__send-button" v-html="$lang('PlaceLandingCost.send')">
                </router-link>

                <div class="cost__sum-right-side">
                    <span class="cost__hint" v-html="$lang('PlaceLandingCost.hint')"></span>

                    <div>
                        {{ sum | priceFormat }}

                        <span class="cost__currency" v-html="$lang('PlaceLandingCost.currency')"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default {
    name: 'PlaceLandingCost',
    data() {
        return {
            sum: 0,
            services: [
                {
                    name: Vue.prototype.$lang('PlaceLandingCost.service1.name'),
                    description: Vue.prototype.$lang('PlaceLandingCost.service1.description'),
                    price: 25000,
                    selected: true
                },
                {
                    name: Vue.prototype.$lang('PlaceLandingCost.service2.name'),
                    description: Vue.prototype.$lang('PlaceLandingCost.service2.description'),
                    price: 10000,
                    selected: false
                },
                {
                    name: Vue.prototype.$lang('PlaceLandingCost.service3.name'),
                    description: Vue.prototype.$lang('PlaceLandingCost.service3.description'),
                    price: 2000,
                    selected: false
                },
                {
                    name: Vue.prototype.$lang('PlaceLandingCost.service4.name'),
                    description: Vue.prototype.$lang('PlaceLandingCost.service4.description'),
                    price: 5000,
                    selected: false
                },
                {
                    name: Vue.prototype.$lang('PlaceLandingCost.service5.name'),
                    description: Vue.prototype.$lang('PlaceLandingCost.service5.description'),
                    price: 20000,
                    selected: false
                },
                {
                    name: Vue.prototype.$lang('PlaceLandingCost.service6.name'),
                    description: Vue.prototype.$lang('PlaceLandingCost.service6.description'),
                    price: 15000,
                    selected: false
                },
                {
                    name: Vue.prototype.$lang('PlaceLandingCost.service8.name'),
                    description: Vue.prototype.$lang('PlaceLandingCost.service8.description'),
                    price: 50000,
                    selected: false
                },
            ]
        }
    },
    watch: {
        services: {
            handler(services) {
                this.updateSum(services);
            },
            deep: true
        }
    },
    mounted() {
        if (window.laravel.locale !== 'ru') {
            return window.location.href = this.$router.resolve({ name: 'place' }).href;
        }

        this.updateSum();
    },
    methods: {
        updateSum(services = this.services) {
            this.sum = services.filter(service => service.selected).reduce(function(previous, current) {
                return previous + current.price;
            }, 0);
        },
        getSelectedServices() {
            return this.services.filter(service => service.selected);
        }
    }
}
</script>
